<div class="customer-search box-container" (ssShowtixKeydownSearch)="search()">
  <form [formGroup]="form">
    <!-- Base Search -->
    <div class="customer-search__base-search">
      <div class="grid grid-cols-2 gap-4">
        <!-- Phone number -->
        <ss-form-field label="Phone Number">
          <input
            ssInput
            ssTrimWhitespace
            minlength="0"
            type="tel"
            formControlName="phoneNumber"
            ssBaseInput
          />
        </ss-form-field>

        <!-- Organization # -->
        <ss-form-field label="Organization">
          <input
            ssInput
            ssTrimWhitespace
            minlength="0"
            type="text"
            formControlName="companyName"
            ssBaseInput
          />
          <ss-form-field-error forError="maxlength">
            Max length of 50 characters
          </ss-form-field-error>
        </ss-form-field>
        <!-- First Name -->
        <ss-form-field label="First Name">
          <input
            ssInput
            ssTrimWhitespace
            minlength="0"
            type="text"
            formControlName="firstName"
            ssBaseInput
          />
          <ss-form-field-error forError="maxlength">
            Max length of 20 characters
          </ss-form-field-error>
        </ss-form-field>

        <!-- Last Name -->
        <ss-form-field label="Last Name">
          <input
            ssInput
            ssTrimWhitespace
            minlength="0"
            type="text"
            formControlName="lastName"
            data-test="customer-search-last-name"
            ssBaseInput
          />
          <ss-form-field-error forError="maxlength">
            Max length of 20 characters
          </ss-form-field-error>
        </ss-form-field>

        @if (openAdvancedSearch || isThereAnyAdvancedSearchField) {
          <!-- Customer Number -->
          <ss-form-field label="Customer Number">
            <input
              ssInput
              ssTrimWhitespace
              minlength="0"
              type="number"
              formControlName="customerNumber"
              data-test="customer-search-customer-number"
              ssBaseInput
            />
          </ss-form-field>
          <!-- Zip code -->
          <ss-form-field label="Zip code">
            <input
              ssInput
              ssTrimWhitespace
              minlength="0"
              type="text"
              formControlName="zipCode"
              ssBaseInput
            />
          </ss-form-field>
          <!-- Email Address -->
          <ss-form-field label="Email Address">
            <input
              ssInput
              ssTrimWhitespace
              minlength="0"
              type="email"
              formControlName="emailAddress"
              ssBaseInput
            />
          </ss-form-field>
          <!-- Customer Attributes -->
          <div>
            <h5>Customer Attributes</h5>
            @if (customerAttributes$ | async; as customerAttributes) {
              <ss-ui-select [data]="customerAttributes">
                <ss-ui-select-trigger
                  ssInput
                  name="customerAttributes"
                  formControlName="customerAttributes"
                  >Select an attribute</ss-ui-select-trigger
                >
              </ss-ui-select>
            }
          </div>
        }
      </div>

      <!-- Advanced Search -->

      <!-- Buttons -->
      <div class="flex customer-search__buttons">
        <div class="flex-auto w-64">
          <!-- Search -->
          <div class="flex gap-2 flex-columns-3">
            <ss-button
              props="normal primary responsive"
              color="primary"
              [disabled]="!form.valid"
              (click)="search()"
              data-test="customer-search"
              >Search</ss-button
            >

            <!-- Advanced Search -->
            <ss-button
              data-test="customer-advanced-search"
              [disabled]="!form.valid"
              props="normal secondary responsive"
              (click)="openCollapseSearch()"
              >{{
                openAdvancedSearch || isThereAnyAdvancedSearchField
                  ? 'Collapsed Search'
                  : 'Advanced Search'
              }}</ss-button
            >

            <!-- Clear -->
            <ss-button
              class="col-span-2"
              props="normal secondary responsive"
              (click)="clearSearchFields()"
              >Clear Search Fields</ss-button
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
